/** Stripe.js `confirmCardPayment` outcome passed to the payment result page. */
export interface StripeSdkPaymentResult {
  orderId: number | string;
  paymentIntentId: string;
  status: string;
}

export type SubscribeBillingPeriod = 'monthly' | 'yearly';

export interface SubscribePaymentResultLocationState {
  stripe: StripeSdkPaymentResult;
  billing: SubscribeBillingPeriod;
  amountLabel: string;
}

export const SUBSCRIBE_PAYMENT_RESULT_PATH = '/subscribe/payment-result';

export function isSubscribePaymentResultState(
  value: unknown,
): value is SubscribePaymentResultLocationState {
  if (!value || typeof value !== 'object') return false;
  const s = value as SubscribePaymentResultLocationState;
  const stripe = s.stripe;
  return (
    (s.billing === 'monthly' || s.billing === 'yearly') &&
    typeof s.amountLabel === 'string' &&
    stripe !== null &&
    typeof stripe === 'object' &&
    (typeof stripe.orderId === 'number' || typeof stripe.orderId === 'string') &&
    typeof stripe.paymentIntentId === 'string' &&
    stripe.paymentIntentId.length > 0 &&
    typeof stripe.status === 'string'
  );
}
